import {Form} from 'antd'
import {useRunWorkflow} from '@/biz/workflow.jsx'
import {TextArea} from '@/components/Form/index.mjs'
import {Prompt, useOpenModal} from '@/components/Modal/index.mjs'

export const canAiGenerateCc = () => () => {
    return function (nodes) {
        return [...nodes].filter(node => {
            const {bizNodeType, pkid, prjId} = node.data

            return (
                prjId === this.data.prjId &&

                (
                    'CAT_ROOT_PRJ' === bizNodeType ||

                    (
                        pkid &&
                        /^(BD|FM)$/.test(bizNodeType)
                    )
                )
            )
        })
    }
}

export const aiGenerateCc = () => () => {
    const openModal = useOpenModal()
    const runWorkflow = useRunWorkflow()

    return async function (nodes) {
        const ns = this.commands.canAiGenerateCc(nodes)

        if (0 === ns.length) {
            return
        }

        const userInput = await openModal(
            <Prompt title="输入提示词">
                <Form.Item
                    label="验收标准的分类提示词"
                    name="rulePrompt"
                >
                    <TextArea />
                </Form.Item>

                <Form.Item
                    label="处理逻辑的分类提示词"
                    name="targetPrompt"
                >
                    <TextArea />
                </Form.Item>
            </Prompt>
        )

        if (! userInput) {
            return
        }

        const {rulePrompt, targetPrompt} = userInput
        const {prjId, sVer} = this.data
        const bdIds = []
        const fmIds = []

        for (const n of ns) {
            const {bizNodeType, pkid} = n.data

            if ('BD' === bizNodeType) {
                bdIds.push(pkid)
            }
            else if ('FM' === bizNodeType) {
                fmIds.push(pkid)
            }
        }

        runWorkflow({
            bizMap: {bdIds, fmIds, prjId, rulePrompt, sVer, targetPrompt},
            scene: 'GENERATE_CC',
        })
    }
}
